import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminSidebar } from './components/sidebar/sidebar';
import { AdminHeader } from './components/header/header';
import { Dashboard } from './pages/dashboard/dashboard';
import { AdminCategories } from './pages/categories/categories';
import { AdminProducts } from './pages/products/products';
import { Orders } from './pages/orders/orders';
import { PaymentStatus } from './pages/paymentStatus/paymentStatus';
import { Invoices } from './pages/invoices/invoices';
import './AdminLayout.css';

export const AdminLayout = () => {
  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-main">
        <AdminHeader />
        <div className="admin-content">
          <Routes>
            <Route path="/" element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="orders" element={<Orders />} />
            <Route path="payment-status" element={<PaymentStatus />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="*" element={<Navigate to="dashboard" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};
